export const integrationAppData = [
    {
        app: 'Mailchimp',
        initials: 'MC',
        type: 'ESP',
        description: 'Sync ECAL subscribers into Mailchimp audiences and automations',
        icon: '/assets/integratedApps/mailchimp.png',
    },
    {
        app: 'HubSpot',
        initials: 'HS',
        type: 'CRM',
        description: 'Push calendar subscribers into HubSpot contacts and lists',
        icon: '/assets/integratedApps/hubspot.png',
    },
    {
        app: 'Salesforce',
        initials: 'SF',
        type: 'CRM',
        description: 'Real-time sync to Sales Cloud leads, contacts and custom objects',
        icon: '/assets/integratedApps/salesforce.png',
    },
    {
        app: 'Braze',
        initials: 'BR',
        type: 'Engagement',
        description: 'Trigger cross-channel journeys from calendar intent signals',
        icon: '/assets/integratedApps/braze.png',
    },
    {
        app: 'Klaviyo',
        initials: 'KL',
        type: 'ESP',
        description: 'Feed profiles and events into Klaviyo flows and segments',
        icon: '/assets/integratedApps/klaviyo.png',
    },
    {
        app: 'Segment',
        initials: 'SG',
        type: 'CDP',
        description: 'Stream ECAL identify and track events to your Segment source',
        icon: '/assets/integratedApps/segment.png',
    },
    {
        app: 'Zoho CRM',
        initials: 'ZC',
        type: 'CRM',
        description: 'Create and enrich Zoho CRM leads from calendar subscriptions',
        icon: '/assets/integratedApps/zoho-crm.png',
    },
    {
        app: 'Marketo Engage',
        initials: 'MK',
        type: 'Automation',
        description: 'Route subscribers into Marketo programs and smart lists',
        icon: '/assets/integratedApps/marketo-engage.png',
    },
    {
        app: 'Iterable',
        initials: 'IT',
        type: 'Engagement',
        description: 'Sync users and calendar events to Iterable for orchestration',
        icon: '/assets/integratedApps/iterable.png',
    },
    {
        app: 'ActiveCampaign',
        initials: 'AC',
        type: 'Automation',
        description: 'Trigger automations from event adds, removals and reminders',
        icon: '/assets/integratedApps/activecampaign.png',
    },
    {
        app: 'Customer.io',
        initials: 'CI',
        type: 'Engagement',
        description: 'Send behavioural campaigns based on calendar engagement',
        icon: '/assets/integratedApps/customer-io.png',
    },
    {
        app: 'Constant Contact',
        initials: 'CC',
        type: 'ESP',
        description: 'Keep Constant Contact lists in sync with ECAL audiences',
        icon: '/assets/integratedApps/constant-contact.png',
    },
    {
        app: 'Sailthru',
        initials: 'ST',
        type: 'Engagement',
        description: 'Enrich Sailthru profiles with calendar intent and interests',
        icon: '/assets/integratedApps/sailthru.png',
    },
    {
        app: 'Pipedrive',
        initials: 'PD',
        type: 'CRM',
        description: 'Create Pipedrive persons and deals from high-intent signals',
        icon: '/assets/integratedApps/pipedrive.png',
    },
    {
        app: 'Zapier',
        initials: 'ZP',
        type: 'Automation',
        description: 'Connect ECAL to 7,000+ apps with no-code Zap triggers',
        icon: '/assets/integratedApps/zapier.png',
    },
];
